import { render, staticRenderFns } from "./Messager.vue?vue&type=template&id=39d50249&scoped=true&"
import script from "./Messager.vue?vue&type=script&lang=js&"
export * from "./Messager.vue?vue&type=script&lang=js&"
import style0 from "./Messager.vue?vue&type=style&index=0&id=39d50249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d50249",
  null
  
)

export default component.exports